export default __webpack_public_path__ + "static/column-ro-43325a18b76312128749ea2ab0ca993d.png";